import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEye3Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.0021 7.20298C9.12633 7.20304 10.0444 8.11732 10.0444 9.2453C10.0441 10.3739 9.12598 11.2869 8.0021 11.287C6.87884 11.2868 5.96138 10.3736 5.96108 9.2453C5.96108 8.11754 6.87849 7.20315 8.0021 7.20298ZM8.0021 8.20298C7.42999 8.20315 6.96108 8.67061 6.96108 9.2453C6.96138 9.82024 7.43001 10.2868 8.0021 10.287C8.5751 10.2869 9.04412 9.82017 9.04442 9.2453C9.04442 8.67068 8.57511 8.20304 8.0021 8.20298ZM2.21304 8.091C4.52511 3.08099 11.4752 3.08099 13.7873 8.091C13.9026 8.34163 13.7937 8.63877 13.5431 8.75442C13.2925 8.87006 12.9955 8.76014 12.8797 8.50962C10.9251 4.27425 5.07518 4.27425 3.12059 8.50962C3.00484 8.76014 2.7078 8.86995 2.45718 8.75442C2.20659 8.63876 2.09762 8.34165 2.21304 8.091Z",
			fill: "currentColor"
		})
	})
});
export default SvgEye3Line;
